import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore }                  from '@store/authStore'
import { ROUTES }                        from '@constants/routes'
import { PageLoader }                    from '@components/feedback/PageLoader'

/**
 * PortalRoute — guards the /portal/* section.
 *
 * Access rules:
 *   - Unauthenticated → /auth/login (preserves attempted URL in `from`)
 *   - role === 'user' OR 'admin' → render (admins may use the portal)
 */
export function PortalRoute() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const isInitializing  = useAuthStore((s) => s.isInitializing)
  const location        = useLocation()

  if (isInitializing) return <PageLoader />

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.AUTH.LOGIN} state={{ from: location }} replace />
  }

  // Both 'user' and 'admin' are allowed in the portal — no role rejection here.
  return <Outlet />
}
